import { render, staticRenderFns } from "./Concatenate.vue?vue&type=template&id=99cb5904"
import script from "./Concatenate.vue?vue&type=script&lang=js"
export * from "./Concatenate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports